import { useLocation } from "react-router-dom";
import { useLogbookContext } from "../../../context";
import { ActivitySection, QueryActivity, TabsItem } from "../../../utils";
import { MainActivityAction } from "./mainActivity";
import { MyActivityAction } from "./myActivity";
import { OneUserActivityAction } from "./oneUser";
import { ActionTabsProps } from "./types";
import { UserListActivityAction } from "./userList";
import { useEffect } from "react";
import { DestinationsAction } from "./destinations";

export const ActionTabs = ({ tab }: ActionTabsProps) => {
    const { state: { activitySection }, changeActivitySection } = useLogbookContext()

    const location = useLocation()
    const queary = new URLSearchParams(location.search)
    const usersIds = queary.get(QueryActivity.IDS)

    useEffect(() => {
        if (usersIds) {
            const idsArray = usersIds.split(",").filter(Boolean);
            if (idsArray.length === 1) {
                changeActivitySection({ value: ActivitySection.ONE_USER_ACTIVITY })
            } else if (idsArray.length > 1) {
                changeActivitySection({ value: ActivitySection.USER_LIST_ACTIVITY })
            }
        } else {
            changeActivitySection({ value: ActivitySection.USER_LIST })
        }
    }, [])

    switch (tab) {
        case TabsItem.ACTIVITY_REGISTER: {
            if (activitySection == ActivitySection.ONE_USER_ACTIVITY) { return <OneUserActivityAction /> }
            if (activitySection == ActivitySection.USER_LIST_ACTIVITY) { return <UserListActivityAction /> }
            return <MainActivityAction />
        }
        case TabsItem.MY_ACTIVITY: {
            return <MyActivityAction />
        }
        case TabsItem.DESTINATION_REGISTERED: {
            return <DestinationsAction />
        }
        default: { return null }
    }
}